export const uniqBy = <T>(arr: T[], key: keyof T): T[] => {
  const map = new Map();
  return arr.filter((item) => {
    const keyValue = item[key];
    return map.has(keyValue) ? false : map.set(keyValue, true);
  });
};
